/**
 * 認証ブートストラップとセッション切れハンドラの共有状態
 */

let bootstrapPromise = null;
let unauthorizedHandler = null;
let suppressUnauthorized = false;

export function resetAuthBootstrap() {
  bootstrapPromise = null;
}

export function runAuthBootstrap(task) {
  if (!bootstrapPromise) {
    bootstrapPromise = task();
  }
  return bootstrapPromise;
}

export function registerUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

export async function notifyUnauthorized() {
  if (suppressUnauthorized || !unauthorizedHandler) return;
  suppressUnauthorized = true;
  try {
    await unauthorizedHandler();
  } finally {
    suppressUnauthorized = false;
  }
}

export async function runWithoutUnauthorizedHandler(task) {
  suppressUnauthorized = true;
  try {
    return await task();
  } finally {
    suppressUnauthorized = false;
  }
}
